import React from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    popoverBox: {
        pointerEvents: "auto",
        border: '1px solid #70707036',
        width: "530px",
        height: "80px",
        background: "#FFFFFF",
        overflow: 'inherit',
        top: '84px !important',
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: '50%',
            width: 0,
            height: 0,
            borderStyle: 'solid',
            top: '-22px',
            borderColor: 'transparent transparent #70707036 transparent',
            borderWidth: '11px',
            transform: 'translateX(-50%)',
        },
        '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: '50%',
            width: 0,
            height: 0,
            borderStyle: 'solid',
            top: '-20px',
            borderColor: 'transparent transparent #fff transparent',
            borderWidth: '10px',
            transform: 'translateX(-50%)',
        }
    },
    drawerPopover: {
        pointerEvents: "none",

    },
    popoverContent: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 20px',
        height: '100%',
        '& img': {
            maxWidth: '50px',
            marginRight: '10px'
        }
    }
}));

export const SidebarColorSchemes = (props) => {
    const {
        open,
        handleOpen,
        handleClose,
        anchorEl,
        drawerBorder,
        currentSelection,
        module,
        ImgUrl
    } = props;
    const classes = useStyles();

    return (
        <div onMouseEnter={handleOpen} onMouseOut={handleClose} className={drawerBorder}>
            <Typography
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
            >
            </Typography>
            <Popover
                id="mouse-over-popover"
                className={classes.drawerPopover}
                classes={{
                    paper: classes.popoverBox
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                onClose={handleClose}
                disableRestoreFocus
            >
                <div className={classes.popoverContent}>
                    <img src={ImgUrl} alt="" />
                    <div style={{ marginLeft: "10px" }}>
                        <text>
                            You are setting up an
                        </text>
                        <text style={{ fontWeight: "bold", textTransform: 'capitalize' }}>
                            {` ${currentSelection?.service_type || ""} ${currentSelection?.service || ""} `}
                        </text>
                        <text>
                            {`${module} here!`}
                        </text>
                    </div>
                </div>
            </Popover>
        </div>)
}
